//50x50
export const fiftyfive=[
    {
        key: 1,
        link:  process.env.PUBLIC_URL + './55x55/stp_ch1_pixeltext.png',
        tag: 'ch1'
    },
    {
        key: 4, 
        link:  process.env.PUBLIC_URL + './55x55/stp_adversary_5050_typed.png',
        tag: 'adversary'
    },
    {
        key: 8, 
        link:  process.env.PUBLIC_URL + './55x55/stp_5050_spectre_typed.png',
        tag: 'spectre'
    },
    

]

export const seventyfive=[
    {
        key: 1,
        link:  process.env.PUBLIC_URL + './75x55/stp_ch1_pixeltext.png',
        tag: 'ch1'

    },
]

export const eightyeight=[
        {
        key: 1,
        link:  process.env.PUBLIC_URL + './88x31/stp_ch1_pristinecut_88x31.png',
        tag: 'ch1'

    },

]

export const hundredbythirty=[
    {
        key: 1,
        link:  process.env.PUBLIC_URL + './100x35/stp_ch1_hundredbythirty.png',
        tag: 'ch1'

    },
]

export const hundredbyfifty=[
        {
        key: 1,
        link:  process.env.PUBLIC_URL + './100x50/stp_ch1_100x50_gif.gif',
        tag: 'ch1'

    },
            {
        key: 2,
        link:  process.env.PUBLIC_URL + './100x50/stp_ch1_100x50.png',
        tag: 'ch1'

    },
]